import React from "react";

/**
 * eBikeGo brand logo — uses the user-uploaded PNG.
 * On light backgrounds the colored helix mark + dark wordmark are crisp.
 */
const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_29456a07-021e-497f-beab-e5053c846a4d/artifacts/g2d5s46f_Main%20Logo.png";

export const Logo = ({ className = "", height = 40 }) => (
  <a
    href="/"
    data-testid="brand-logo"
    aria-label="eBikeGo Store — home"
    className={`inline-flex items-center gap-2 ${className}`}
  >
    <img
      src={LOGO_URL}
      alt="eBikeGo"
      style={{ height: `${height}px`, width: "auto" }}
      className="select-none transition-transform duration-500 group-hover:scale-105"
    />
    <span
      data-testid="brand-store-tag"
      className="font-outfit font-normal text-slate-400 tracking-tight text-xl sm:text-2xl leading-none -ml-1 relative top-[3px]"
    >
      Store
    </span>
  </a>
);

export default Logo;
